import { getRequest } from '../api/ApiController';

const LOOKUP_URL = '/api/training_invitation_templates';

let inFlight = null;

export function areTrainingInvitationTemplatesLoaded(state) {
  return state?.training_invitation_templates_loaded === true;
}

export function selectTrainingInvitationTemplates(state) {
  return Array.isArray(state?.training_invitation_templates) ? state.training_invitation_templates : [];
}

export function extractTrainingInvitationTemplateRows(response) {
  if (Array.isArray(response?.data)) return response.data;
  if (Array.isArray(response)) return response;
  return null;
}

export function applyTrainingInvitationTemplates(dispatch, rows) {
  dispatch({
    type: 'load_training_invitation_templates',
    newTrainingInvitationTemplates: Array.isArray(rows) ? rows : [],
  });
}

export function hydrateTrainingInvitationTemplatesFromAuthPayload(dispatch, responseData) {
  if (!responseData || typeof responseData !== 'object' || Array.isArray(responseData)) {
    return false;
  }
  if (!Object.prototype.hasOwnProperty.call(responseData, 'training_invitation_templates')) {
    return false;
  }
  const rows = Array.isArray(responseData.training_invitation_templates)
    ? responseData.training_invitation_templates
    : [];
  applyTrainingInvitationTemplates(dispatch, rows);
  return true;
}

export function refreshTrainingInvitationTemplates({ dispatch, request = getRequest } = {}) {
  if (inFlight) return inFlight;
  try {
    inFlight = Promise.resolve(request(LOOKUP_URL))
      .then((response) => {
        const rows = extractTrainingInvitationTemplateRows(response);
        if (rows == null) {
          throw new Error('Unable to load training invitation templates');
        }
        applyTrainingInvitationTemplates(dispatch, rows);
        return rows;
      })
      .finally(() => {
        inFlight = null;
      });
  } catch (error) {
    inFlight = null;
    return Promise.reject(error);
  }
  return inFlight;
}

export function ensureTrainingInvitationTemplatesLoaded({ dispatch, state, request = getRequest } = {}) {
  if (areTrainingInvitationTemplatesLoaded(state)) {
    return Promise.resolve(selectTrainingInvitationTemplates(state));
  }
  return refreshTrainingInvitationTemplates({ dispatch, request });
}

export function resetTrainingInvitationTemplatesLookupForTests() {
  inFlight = null;
}
